import BGPH1 from '../../../assets/images/backgrounds/OurTeam.png'
import { Link } from 'react-router-dom'
import React from 'react'

import TEAM1 from '../../../assets/images/team/team/1.png'
import TEAM2 from '../../../assets/images/team/team/2.png'
import TEAM3 from '../../../assets/images/team/team/3.png'
import TEAM4 from '../../../assets/images/team/team/4.png'
import TEAM5 from '../../../assets/images/team/team/5.png'
import TEAM6 from '../../../assets/images/team/team/6.png'
import TEAM7 from '../../../assets/images/team/team/7.png'
import TEAM8 from '../../../assets/images/team/team/8.png'
import TEAM9 from '../../../assets/images/team/team/9.png'
import TEAM10 from '../../../assets/images/team/team/10.png'
import TEAM11 from '../../../assets/images/team/team/11.png'
import TEAM12 from '../../../assets/images/team/team/12.png'
import TEAM13 from '../../../assets/images/team/team/13.png'
import TEAM14 from '../../../assets/images/team/team/14.png'
import TEAM15 from '../../../assets/images/team/team/15.png'
import TEAM16 from '../../../assets/images/team/team/16.png'
import TEAM17 from '../../../assets/images/team/team/17.png'
import TEAM18 from '../../../assets/images/team/team/18.png'
import TEAM19 from '../../../assets/images/team/team/19.png'
import TEAM20 from '../../../assets/images/team/team/20.png'


const Team = () => {
    return (
        <>
            <div className="stricky-header stricked-menu main-menu">
                <div className="sticky-header__content"></div>
            </div>
            <section className="page-header">
                <div className="page-header__bg" style={{ backgroundImage: `url(${BGPH1})` }}></div>
                <div className="container">
                    {/* <ul className="thm-breadcrumb list-unstyled">
                    <li><Link to="/">Home</Link></li>
                    <li><span>Team</span></li>
                </ul> */}
                    <h2>Our Team</h2>
                </div>
            </section>

            <section className="team-grid pt-120 pb-120">
                <div className="container">
                    <div className="row row-gutter-y-30">
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM1} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Shajin Kesikkaran
                                        </h3>
                                        <p className="team-card__designation">East Melbourne Region
                                        </p>
                                        <p className="mt-4">Addon Brokers

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM2} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Tarun Parmar
                                        </h3>
                                        <p className="team-card__designation">South East Melbourne Region


                                        </p>
                                        <p className="mt-4">Addon Brokers

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM3} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Dr.Shaji Varghese

                                        </h3>
                                        <p className="team-card__designation">Melbourne Region




                                        </p>
                                        <p className="mt-4">Pheonix Financial Services


                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM4} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Paul Mathew


                                        </h3>
                                        <p className="team-card__designation">South East Melbourne Region

                                        </p>
                                        <p className="mt-4">4u Loans

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM5} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Ranjit Singh

                                        </h3>
                                        <p className="team-card__designation">North Melbourne Region

                                        </p>
                                        <p className="mt-4">Addon Brokers

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM6} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Raman Singh


                                        </h3>
                                        <p className="team-card__designation">East Melbourne Region



                                        </p>
                                        <p className="mt-4">Armahi Loans


                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM7} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Pradeep Srivastava

                                        </h3>
                                        <p className="team-card__designation">East Melbourne Region

                                        </p>
                                        <p className="mt-4">Srivas Finance

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM8} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Jatinder Pal Singh


                                        </h3>
                                        <p className="team-card__designation">South East Melbourne Region



                                        </p>
                                        <p className="mt-4">Addon Brokers


                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM9} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Sunny Singh Sehdev

                                        </h3>
                                        <p className="team-card__designation">South East Melbourne Region


                                        </p>
                                        <p className="mt-4">Instant Mortgage Brokers


                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM10} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Kaumil Patel


                                        </h3>
                                        <p className="team-card__designation">Melbourne Region




                                        </p>
                                        <p className="mt-4">Lending R Us



                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM11} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Mital Shah



                                        </h3>
                                        <p className="team-card__designation">South East Melbourne Region






                                        </p>
                                        <p className="mt-4">Addon Brokers




                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM12} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Manvinder Singh

                                        </h3>
                                        <p className="team-card__designation">South East Melbourne Region

                                        </p>
                                        <p className="mt-4">Armaan Loans


                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM13} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Gurdev Dhanoa


                                        </h3>
                                        <p className="team-card__designation">South East Melbourne Region



                                        </p>
                                        <p className="mt-4">Addon Brokers


                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM14} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Jayesh Dangodara

                                        </h3>
                                        <p className="team-card__designation">South East Melbourne Region


                                        </p>
                                        <p className="mt-4">Dpoint Mortgage

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM15} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Sukhwant Singh


                                        </h3>
                                        <p className="team-card__designation">West Melbourne Region




                                        </p>
                                        <p className="mt-4">Addon Brokers


                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM16} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Bobish Jose


                                        </h3>
                                        <p className="team-card__designation">South East Melbourne Region


                                        </p>
                                        <p className="mt-4">AU Kart Loans

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM17} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Shagoun Vaid

                                        </h3>
                                        <p className="team-card__designation">Casey & Cardinia Region

                                        </p>
                                        <p className="mt-4">Book A Broker

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM18} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Purushottam Budhathoki


                                        </h3>
                                        <p className="team-card__designation">North Melbourne Region



                                        </p>
                                        <p className="mt-4">Addon Brokers


                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM19} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">Navjot Singh



                                        </h3>
                                        <p className="team-card__designation">Wyndham Region





                                        </p>
                                        <p className="mt-4">Addon Brokers



                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xl-3 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="000ms">
                            <div className="team-card">
                                <div className="team-card__image">
                                    <img src={TEAM20} alt="Connor Estrada" />
                                    <div className="team-card__social">
                                        {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                        <Link to="#"><i className="fab fa-facebook"></i></Link>
                                        <Link to="#"><i className="fab fa-linkedin"></i></Link>
                                        {/* <Link to="#"><i className="fab fa-pinterest"></i></Link> */}
                                        {/* <Link to="#"><i className="fab fa-instagram"></i></Link> */}
                                    </div>
                                </div>
                                <div className="//team-card__content">
                                    <div className="team-card__content__inner">
                                        <h3 className="team-card__title">PAM




                                        </h3>
                                        <p className="team-card__designation">PAM Business Solutions







                                        </p>
                                        <p className="mt-4">Addon Brokers



                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Link to="#" data-target="html" className="scroll-to-target scroll-to-top"><i className="fa fa-angle-up"></i></Link>
        </>
    )
}

export default Team